export enum PaymentSelectionHook {
  Payment_Selection = 'payment-selection',
  Title = 'title',
  Divider = 'divider',
  Payment_Selection_Label = 'payment-selection-label',
  Payment_Type = 'payment-type',
}
